export const videoContainer = "vazl02";
export const video = "vbyyxvw";
export const infoBlock = "is0hiii";
export const info = "i158ucrg";

require("./style.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");